"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazy = (f) => {
    let value;
    return () => {
        if (!value) {
            value = f();
        }
        return value;
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGF6eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL2xhenkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBYSxRQUFBLElBQUksR0FBRyxDQUFJLENBQVUsRUFBRSxFQUFFO0lBQ2xDLElBQUksS0FBb0IsQ0FBQTtJQUN4QixPQUFPLEdBQUcsRUFBRTtRQUNSLElBQUksQ0FBQyxLQUFLLEVBQUU7WUFDUixLQUFLLEdBQUcsQ0FBQyxFQUFFLENBQUE7U0FDZDtRQUNELE9BQU8sS0FBSyxDQUFBO0lBQ2hCLENBQUMsQ0FBQTtBQUNMLENBQUMsQ0FBQSJ9